import React, { useEffect, useState } from "react";
import Left_menu from "./Left_menu";
import Header from "./Header";
import axios from "axios";
import Swal from "sweetalert2";
import config from "../../config";
import { useNetworkState } from "react-use";
import Footer from "../Footer";

const Channel_add = () => {
  const isOnline = useNetworkState();
  // console.log("isONline  === " ,isOnline )
  let userDetail = localStorage.getItem("ship_rocket_user");
  // // console.log("userDetail====shipments====", config.UserId);
  let userData = {};
  if (userDetail != null) {
    userData = JSON.parse(userDetail);
  }
  const [state, setState] = React.useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
  const [storeName, setStoreName] = React.useState("");
  const [storeUrl, setStoreUrl] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    const homeSection = document.querySelector(".home-section");
    if (homeSection) {
      homeSection.classList.toggle("sidebar-closed");
    }
  };

  React.useEffect(() => {
    getChannelList();
  }, []);
  const Toast = Swal.mixin({
    toast: true,
    position: "bottom-end",
    showConfirmButton: false,
    timer: 3000,
  });
  const getChannelList = () => {
    let url = config.apiUrl + "/user/channel_find";
    let sendData = {};
    // // console.log("bb", sendData);
    axios
      .post(url, sendData, { headers: config.headers })
      .then((res) => {
        // // console.log("res ", res);
        if (res.data.status == true) {
          setState(res.data.output);
        } else {
          Toast.fire({
            background: "#c2200a",
            type: "unsuccess",
            title: "Something Went Wrong",
            color: "white",
          });
        }
      })
      .catch((e) => {
        Toast.fire({
          background: "#c2200a",
          type: "unsuccess",
          title: "Something Went Wrong",
          color: "white",
        });
      });
  };

  const connectStore = async () => {
    if (!storeName.trim()) {
      Toast.fire({
        background: "#c2200a",
        type: "unsuccess",
        title: "Please enter Store Name",
        color: "white",
      });
      return;
    }

    if (!storeUrl.trim()) {
      Toast.fire({
        background: "#c2200a",
        type: "unsuccess",
        title: "Please enter Store URL",
        color: "white",
      });
      return;
    }

    try {
      setLoading(true);

      const customer_id = userData.customer_id; // update according to your project

      const response = await axios.post(
        `${config.apiUrl}/wocommerce/oauthStart`,
        {
          customer_id,
          store_name: storeName,
          store_url: storeUrl,
        },
        {
          headers: config.headers,
        }
      );

      if (response.data.success) {
        window.location.href = response.data.data.redirect_url;
      } else {
        Toast.fire({
          background: "#c2200a",
          type: "unsuccess",
          title: response.data.message,
          color: "white",
        });
      }
    } catch (err) {
      console.log(err);
      Toast.fire({
        background: "#c2200a",
        type: "unsuccess",
        title: err.response?.data?.message || "Something went wrong.",
        color: "white",
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      <Left_menu isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

      <div className="home-section">
        <Header />

        <section class="mb-3  tools">
          <div class="">
            <div class="row ">
              <div class="col-12 col-md">
                <h2>Connect a Channel</h2>
              </div>
              <div class="col-12 col-md-4 text-end"></div>
            </div>
            <div class="row chanel_list">
              {state.length > 0
                ? state.map((sub) => (
                    <div class="col-12 col-md-4 mb-3">
                      <div class="card  shadow-sm ">
                        <div class="card-body">
                          <div class="text-center">
                            <figure>
                              <img
                                src={`https://kourier-admin-panel.s3.ap-south-1.amazonaws.com/channel_images/${sub.channel_img}`}
                                class="img-fluid"
                                style={{ height: "100px" }}
                              />
                            </figure>
                            <h4>{sub.channel_name}</h4>
                          </div>

                          <hr />
                          <div class="text-center">
                            {sub.channel_id == "1567898605" ? (
                              <a
                                href={`/customer/shopify_connect`}
                                class="btn btn-primary btn-sm"
                              >
                                Integrate
                              </a>
                            ) : (
                              <a
                                href={`/customer/channel_integrate/${sub.channel_id}`}
                                class="btn btn-primary btn-sm"
                              >
                                Integrate
                              </a>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                : ""}
              <div className="col-12 col-md-4 mb-3">
                <div className="card shadow-sm">
                  <div className="card-body">
                    <div className="text-center">
                      <img
                        src="https://kourier-admin-panel.s3.ap-south-1.amazonaws.com/channel_images/wooCommerce.png"
                        className="img-fluid"
                        style={{ height: "90px" }}
                        alt="WooCommerce"
                      />

                      <h4 className="mt-3">WooCommerce</h4>
                    </div>

                    <hr />

                    <div className="mb-3">
                      <label className="form-label">Store Name</label>

                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Store Name"
                        value={storeName}
                        onChange={(e) => setStoreName(e.target.value)}
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Store URL</label>

                      <input
                        type="text"
                        className="form-control"
                        placeholder="https://yourstore.com"
                        value={storeUrl}
                        onChange={(e) => setStoreUrl(e.target.value)}
                      />
                    </div>

                    <div className="text-center">
                      <button
                        className="btn btn-primary w-100"
                        disabled={loading}
                        onClick={connectStore}
                      >
                        {loading ? "Connecting..." : "Integrate"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <?php include 'footer.php';?> */}
      </div>
      <Footer />
    </div>
  );
};

export default Channel_add;
